import React from 'react';
import { connect } from 'react-redux';
import BaseComponent from '../../baseClasses/BaseComponent';
import PopupMenu from '../../components/PopupMenu';
import caret from '../../assets/images/caret.svg';
import './SelectCompanyComboBox.scss';
import Input from '../Input';

export class SelectCompanyComboBox extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = {
      selected: false,
    };
    
    this.state.initialValue = this.props.initialValue ? this.props.initialValue : '';
  }

  setFocus() {
    if (this.comboBox) {
      this.comboBox.blur();
     // this.comboBox.setAttribute("tabIndex", Math.ceil(Math.random() * 100))
      if (!this.props.ubication) {
        
      } 
    }
  }

  filterCompanyList() {
    const { companies } = this.props;
    const { filterCompanies } = this.props;
    let companiesFiltered = null;
    if (companies && companies.length > 0) {
      if (filterCompanies) {
        companiesFiltered = companies.filter(companies => {
          const isFiltered = filterCompanies.filter(filterCompany => {
            return (filterCompany && filterCompany.companies ? filterCompany.companies.id == companies.id : filterCompany.id == companies.id);
          });
          return isFiltered.length == 0;
        }
        );
      }
      else {
        companiesFiltered = companies.filter(company => {
          return true;
        });
      }
    }
    return companiesFiltered;
  }

  componentDidMount() {
   // this.setFocus()
  }

  handleCloseMenu(type, esc) {
    this.setState({
      menu: null,
    });
    this.setFocus();
  }

  handleClick(e) {
    this.comboBox.blur();
    if (!this.state.menu) {
      if (e) {
        e.stopPropagation();
      }
      const menu = this.createComboBoxMenu(this.tempInitialValue);
      if (this.menuOptions.length > 0) {
        this.tempInitialValue = null;
        this.setState({ menu: menu });
      }
    }
    this.setFocus();
  }

  createComboBoxMenu(initialValue) {
    const { menuUp, height, multiSelect, menuBelow } = this.props;
    const { currentSelectedCompany, selectedCompanies } = this.props;
    let maxHeight = this.props.maxHeight ? this.props.maxHeight : null;

    let companiesFiltered = this.filterCompanyList();
    this.menuOptions = companiesFiltered ? companiesFiltered.map((company) => {
      let selected = false;
      if (selectedCompanies) {
        const isSelected = selectedCompanies.filter(searchCompany => {
          return company.id == searchCompany.id;
        });
        selected = isSelected.length > 0;
      }
      else if (this.props.selectedCompanies) {
        const findCompany = this.props.selectedCompanies.filter(searchCompany => {
          return searchCompany.id == company.id;
        });
        if (findCompany.length > 0) {
          selected = true;
        }
      }
      else if (currentSelectedCompany) {
        if (company.id == currentSelectedCompany.id) {
          selected = true;

        }
        else {
          selected = false;
        }
      }
      else {
        selected = false;
      }
      return ({
        type: company.id, name: company.name, company: company,
        dismiss: !multiSelect, selected: selected,
      });
    }) : [];
    let menu = null;

    if (!this.props.dontSortMenu) {
      this.menuOptions.sort((opt1, opt2) => {
        if (opt1.name && opt2.name && opt1.name.toLowerCase() < opt2.name.toLowerCase()) {
          return -1;
        }
        else if (opt1.name && opt2.name && opt1.name.toLowerCase() > opt2.name.toLowerCase()) {
          return 1;
        }
        else {
          return 0;
        }
      });
    }
    if (this.props.allowAdd) {
      this.menuOptions.splice(0, 0, { type: -1, name: '-- Create Company --' });
    }
    let verticalPosition = menuUp ? 32 : height ? height + 3 : 33;
    let pointerPosition = '';
    if (multiSelect && !menuBelow) {
      pointerPosition = 'right';
    }

    if (menuUp) {
      menu = <PopupMenu left={0} bottom={verticalPosition} width={this.props.width} height={this.props.menuHeight} initialValue={initialValue}
        noBackground={this.props.noBackground}
        backgroundIndex={this.props.backgroundIndex}
        menuOptions={this.menuOptions} size="small"
        menuId={'companiesSelectionMenu' + Math.floor(Math.random() * 1000)} popupOnHover={false}
        handleMenuSelection={this.handleComboboxMenuSelection} handleMultiMenuSelection={this.handleMultiMenuSelection}
        handleClickAway={this.handleCloseMenu}
        showSearchBar={this.props.showSearchBar}
        searchHint={this.props.searchHint}
        maxHeight={maxHeight} multiSelect={multiSelect} pointerPosition={pointerPosition} />;
    }
    else {
      menu = <PopupMenu left={0} top={verticalPosition} width={this.props.width} height={this.props.menuHeight} initialValue={initialValue}
        noBackground={this.props.noBackground} 
        backgroundIndex={this.props.backgroundIndex}
        menuOptions={this.menuOptions} size="small"
        menuId={'companiesSelectionMenu' + Math.floor(Math.random() * 1000)} popupOnHover={false}
        handleMenuSelection={this.handleComboboxMenuSelection} handleMultiMenuSelection={this.handleMultiMenuSelection}
        handleClickAway={this.handleCloseMenu}
        showSearchBar={this.props.showSearchBar}
        searchHint={this.props.searchHint}
        maxHeight={maxHeight} multiSelect={multiSelect} pointerPosition={pointerPosition} />;
    }
    return menu;
  }

  handleMultiMenuSelection(multipleOptions, selectedOption) {
    const { handleMultipleSelection } = this.props;
    if (handleMultipleSelection) {
      handleMultipleSelection(multipleOptions.map(option => { return option.company; }), selectedOption);
    }
  }

  handleComboboxMenuSelection(type, keyboardSelected) {
    const { handleSelection, multiSelect } = this.props;
    if (multiSelect) {
    }
    else {
      const optionSelectedBase = this.menuOptions.filter(option => {
        return option.type.toString() == type.toString();
      });
      let optionSelected = null;
      if (optionSelectedBase && optionSelectedBase.length > 0) {
        optionSelected = optionSelectedBase[0];
        optionSelected.selected = !optionSelected.selected;
        this.setState({ optionSelected: optionSelected });
      }
      if (!keyboardSelected) {
        this.setState({ menu: null, initialValue: '' });
        if (handleSelection) {
          if (optionSelected.company) {
            handleSelection(optionSelected.company);
          }
          else {
            handleSelection(null);
          }
        }
      }
    }
  }

  handleHideInput(e){
    this.comboBox.blur();
  }
  handleKeyDown(e) {
    this.comboBox.blur();
    if(this.state.menu){
      return;
    }
    if (e.keyCode == 13 || e.keyCode == 40) {
      this.handleClick();
    }
    else if (e.keyCode == 27) {
      const { handleEscape } = this.props;
      if (handleEscape) {
        handleEscape();
      }
    }
    else if (e.keyCode == 9) {
      e.preventDefault();
    }
    else {
      if (e.key.length == 1) {
        this.setState({ initialValue: e.key });
        this.tempInitialValue = e.key;
        this.handleClick(e);
      }
    }
  } 

  handleInput(e) {
    
  }
  
  render() {
    const { width, height, hasBorder, underlined, displayFontStyle, label, tabIndex,
      makeAbsolute, top, left, currentSelectedCompany, selectedCompanies } = this.props;

    let companiesFiltered = this.filterCompanyList();
    let currentOptionName = companiesFiltered && companiesFiltered.length > 0 ? 'None Selected' : 'None Available';
    if (selectedCompanies) {
      if (selectedCompanies.length == 1) {
        currentOptionName = selectedCompanies[0].name;
      }
      else if (selectedCompanies.length > 1) {
        currentOptionName = this.textMap.multipleSelected;
      }
    }
    else if (this.state.initialValue) {
      currentOptionName = this.state.initialValue;
    }
    else if (currentSelectedCompany && currentSelectedCompany.name) {
      currentOptionName = currentSelectedCompany.name;
    }
    let style = { width: width + 'px', height: height + 'px' };
    if (makeAbsolute) {
      style.position = 'absolute';
      style.left = left;
      style.top = top;
    }
    const boxClass = 'display-box ' + (hasBorder ? 'bordered' : '') + (underlined ? ' underlined' : '');
    const comboboxMenu = this.state.menu;
    let labelDisplay = null;
    if (label) {
      labelDisplay = <div className="select-company-combo-box-label">{label}</div>;
    }

    return (
      <div id={this.props.id} tabIndex={tabIndex} className="select-company-combo-box" style={style} onMouseDown={this.handleClick} onKeyDown={this.handleKeyDown}>
        <div className="popup-menu-container">
          {comboboxMenu}
        </div>
        {labelDisplay}
        <div className={boxClass}>
          <Input className="focus-box" readOnly={true} onKeyDown={this.handleKeyDown} onMouseDown={this.handleHideInput} ref={(element) => {
            this.comboBox = element;
          }} value={this.state.initialValue} />
          <div className={'selected-value' + (this.props.adjustHeight ? ' adjust-height' : '')} style={displayFontStyle}>{currentOptionName}</div>
          <img className="caret" src={caret} alt="DropDown" />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    permissions: state.new_users.permissions,
    currentCompany: state.new_companies.currentCompany,
    currentUser: state.new_users.currentUser,
  };
};

export default connect(mapStateToProps, null)(SelectCompanyComboBox);



// WEBPACK FOOTER //
// ./src/components/SelectCompanyComboBox/index.js